import { VIEW_CLAIMS } from '@/common/permissionConstants';
import { useDevOnly } from '@/composables/useDevOnly';

const devOnlyGuard = () => {
    const { isRcmRailPreview } = useDevOnly();
    if (!isRcmRailPreview()) return { name: 'home' };
};

export default [
    {
        path: 'availity/remittances',
        name: 'availity-remittances',
        meta: { label: 'Remittance review', hasPermission: VIEW_CLAIMS },
        component: () => import('@/views/AvailityEraReviewPage.vue'),
        beforeEnter: devOnlyGuard,
    },
    {
        path: 'availity/files',
        name: 'availity-files',
        meta: { label: 'Availity file activity', hasPermission: VIEW_CLAIMS },
        component: () => import('@/views/AvailityFilesPage.vue'),
        beforeEnter: devOnlyGuard,
    },
];
